import { HowPayable, WhenPayable } from './types';

export const intermediaryFeesQuestions: Record<string, any> = {
  hasIntermediaryFees: {
    id: 'hasIntermediaryFees',
    labelKey: 'applicationForm.INTERMEDIARY_FEES.hasIntermediaryFees.label',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  fees: {
    description: {
      id: 'intermediaryFeesDescription',
      labelKey: 'applicationForm.INTERMEDIARY_FEES.fees.description.columnLabel',
    },
    amount: {
      id: 'intermediaryFeesAmount',
      labelKey: 'applicationForm.INTERMEDIARY_FEES.fees.amount.columnLabel',
    },
    whenPayable: {
      id: 'intermediaryFeesWhenPayable',
      labelKey: 'applicationForm.INTERMEDIARY_FEES.fees.whenPayable.columnLabel',
      options: [
        { label: WhenPayable.ON_OFFER, value: WhenPayable.ON_OFFER },
        { label: WhenPayable.ON_APPLICAION, value: WhenPayable.ON_APPLICAION },
        { label: WhenPayable.ON_COMPLETION, value: WhenPayable.ON_COMPLETION },
      ],
    },
    howPayable: {
      id: 'intermediaryFeesHowPayable',
      labelKey: 'applicationForm.INTERMEDIARY_FEES.fees.howPayable.columnLabel',
      options: [{ label: HowPayable.PAID_DIRECT_TO_BROKER, value: HowPayable.PAID_DIRECT_TO_BROKER }],
    },
    refundableAmount: {
      id: 'intermediaryFeesRefundableAmount',
      labelKey: 'applicationForm.INTERMEDIARY_FEES.fees.refundableAmount.columnLabel',
    },
  },
};
